import moment from "moment";
import {ScheduleType, ScheduleTypeOptions} from "models/model";



export function parseExcel(buffer: Buffer) {
    const XLSX = require('xlsx')
    const workbook = XLSX.read(buffer)
    const firstSheetName = workbook.SheetNames[0]
    const worksheet = workbook.Sheets[firstSheetName]
    return XLSX.utils.sheet_to_json(worksheet)
}

export function formatDate(date: string, haveTime?: boolean) {
    if(haveTime){
        return moment(new Date(date)).format('DD/MM/YYYY HH:mm')
    }
    return moment(new Date(date)).format('DD/MM/YYYY')
}

export const getTypeLabel = (type: ScheduleType) => {
    const option = ScheduleTypeOptions.find(opt => opt.value === type);
    return option ? option.label : 'Khác';
};

export const getEventColor = (type: ScheduleType) => {
    switch (type) {
        case ScheduleType.LyThuyet:
            return 'bg-blue-50 border-l-4 border-blue-400 text-blue-800' // Lý thuyết
        case ScheduleType.ThucHanhTrongHinh:
            return 'bg-green-50 border-l-4 border-green-400 text-green-800' // Thực hành trong hình
        case ScheduleType.ThucHanhTrenDuong:
            return 'bg-purple-50 border-l-4 border-purple-400 text-purple-800' // Thực hành trên đường
        case ScheduleType.KiemTra:
            return 'bg-red-50 border-l-4 border-red-400 text-red-800' // Kiểm tra
        case ScheduleType.NghiDuPhong:
            return 'bg-gray-50 border-l-4 border-gray-400 text-gray-800' // Nghỉ dự phòng
        default:
            return 'bg-yellow-50 border-l-4 border-yellow-400 text-yellow-800' // Mặc định
    }
}